export enum ProdutoTipoEnum {
    eCPF = 1,
    eCPFDescription = 'e-CPF',
    eCNPJ = 2,
    eCNPJDescription = 'e-CNPJ',
    eServidor = 3,
    eServidorDescription = 'e-Servidor',
    eAplicacao = 4,
    eAplicacaoDescription = 'e-Aplicação',
    eCodigo = 5,
    eCodigoDescription = 'e-Código',
    ePF = 6,
    ePFDescription = 'e-PF',
    ePJ = 7,
    ePJDescription = 'e-PJ'
}
